import o from "./td-longtail-vue-components247.js";
import i from "./td-longtail-vue-components248.js";
/* empty css                              */
import a from "./td-longtail-vue-components98.js";
const m = {
  name: "BundleConfiguratorItem",
  components: { CompactItemInfo: o, ExtendedItemInfo: i },
  props: {
    bundleItem: { type: Object, default: () => ({}) },
    isExtended: Boolean
  },
  emits: ["open-bundle-item-config", "select-variant"]
};
var r = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "item" }, [t("CompactItemInfo", { attrs: { name: e.bundleItem.family.name, "active-variants": e.bundleItem.activeVariants, "is-configurable": e.bundleItem.isConfigurable, position: e.bundleItem.position, "is-extended": e.isExtended }, on: { "open-bundle-item-config": (n) => e.$emit("open-bundle-item-config", n) } }), t("ExtendedItemInfo", { attrs: { "is-extended": e.isExtended, "bundle-item": e.bundleItem }, on: { "select-variant": (n) => e.$emit("select-variant", n) } })], 1);
}, s = [], d = /* @__PURE__ */ a(
  m,
  r,
  s,
  !1,
  null,
  "7586a143"
);
const I = d.exports;
export {
  I as default
};
